import { fetchDataAndProceed } from '../../config/utils';
import { METHOD_TYPES } from '../../config/constants';

//------------------------------ AGENTS --------------------------------

export const getAllAgents = (data, callback) => {
    return fetchDataAndProceed('/users/admins/getAgentList', METHOD_TYPES.GET, data, callback);
};

export const inviteNewAgents = (data, callback) => {
    return fetchDataAndProceed('/users/admins', METHOD_TYPES.POST, data, callback);
};

export const getAgentProfileDetails = (data, callback) => {
    return fetchDataAndProceed('/users/admins/getSingleUser', METHOD_TYPES.GET, data, callback);
};

export const updateAgent = (data, callback) => {
    return fetchDataAndProceed('/users/admins/updateUserProfile', METHOD_TYPES.POST, data, callback);
};

export const deleteAgent = (data, callback) => {
    return fetchDataAndProceed('/users/admins', METHOD_TYPES.DELETE, data, callback);
};

export const resetPassWord = (data, callback) => {
    return fetchDataAndProceed('/users/password/change', METHOD_TYPES.POST, data, callback);
};

//------------------------------ GROUPS --------------------------------

export const getAllGroups = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/agentGroupList', METHOD_TYPES.GET, data, callback);
};

export const getGroupDetails = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/agentGroup', METHOD_TYPES.GET, data, callback);
};

export const createGroup = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/agentGroup', METHOD_TYPES.POST, data, callback);
};

export const updateGroup = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/agentGroup', METHOD_TYPES.PUT, data, callback);
};

export const deleteGroup = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/agentGroup', METHOD_TYPES.DELETE, data, callback);
};

//------------------------------ CANNED RESPONSES --------------------------------

export const getAgentCannedResponses = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/cannedResponse', METHOD_TYPES.GET, data, callback, 0);
};

export const createCannedResponse = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/cannedResponse', METHOD_TYPES.POST, data, callback);
};

export const updateCannedResponse = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/cannedResponse', METHOD_TYPES.PUT, data, callback);
};

export const deleteCannedResponse = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/cannedResponse', METHOD_TYPES.DELETE, data, callback);
};

//----------------------------- TAGS ------------------------------------------------------


export const getAllTags = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/tag', METHOD_TYPES.GET, data, callback);
};

export const createTag = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/tag', METHOD_TYPES.POST, data, callback);
};

export const updateTag = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/tag', METHOD_TYPES.PUT, data, callback);
};

export const deleteTag = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/tag', METHOD_TYPES.DELETE, data, callback);
};



// WEBPACK FOOTER //
// ./src/data/redux/member_details/api.js